import React from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import LastSeenHotelsComponent from 'components/domain/last-seen-hotels/LastSeenHotelsComponent';
import { ILastSeenHotelsComponentProps } from './lastSeenHotels.types';

const SrlPdpLastSeenHotelsWrap = styled.div(
  sx2CssThemeFn({
    pt: [0, '40px'],
    h3: {
      fontSize: ['18px', 3],
    },
    '> div': {
      pb: [0, '32px'],
    },
  })
);

const SrlPdpLastSeenHotels: React.FC<ILastSeenHotelsComponentProps> = ({
  lastSeenHotels,
}) => {
  return (
    <SrlPdpLastSeenHotelsWrap>
      <LastSeenHotelsComponent lastSeenHotels={lastSeenHotels} />
    </SrlPdpLastSeenHotelsWrap>
  );
};

export default SrlPdpLastSeenHotels;
